module.exports = __webpack_public_path__ + "static/media/HAUX_MAIS_VIDA_1.dbaa12a9.pdf";